<template>
  <div>
    <div v-if="item" class="">
        <span v-if="item.street_address" class="">{{ item.street_address }}, <br /></span> 
        <span class="" v-if="item.lga">{{ item.lga.name }}, </span>
        <span class="" v-if="item.state">{{ item.state.name }}</span>
    </div>
</div> 
</template>

<script>
export default {
    props:{
        item: {
            type: Object,
        }
    }
}
</script>

<style>

</style>